(function () {
    "use strict";

    angular.module('app').directive('fodbzHelpedCheckbox', HelpedCheckboxDirective);

    HelpedCheckboxDirective.$inject = [];
    function HelpedCheckboxDirective() {
        return {
            transclude: true,
            // eslint-disable-next-line angular/no-directive-replace
            replace: true,
            scope: {
                fodbzModel: '=',
                fodbzFieldConst: '@',
                fodbzResource: '@',
                fodbzInfo: '@',
                fodbzInfoTitle: '@'
            },
            template: `
                <div class="form-horizontal">
                    <div class="input-group" style="width:100%">
                        <input ng-model="fodbzModel"
                               type="checkbox"
                               id="{{fodbzFieldConst}}" 
                               name="{{fodbzFieldConst}}">
                                &nbsp; &nbsp;
                        <label for="{{fodbzFieldConst}}"
                               class="control-label"
                               style="font-weight: normal;">
                               {{fodbzResource}} 
                        </label>
                        <span data-toggle="popover"
                              title="{{fodbzInfo}}"
                              data-content="{{fodbzInfo}}"  
                              style="cursor:pointer"  
                              data-original-title="{{fodbzInfoTitle}}"> 
                                <span class="glyphicon glyphicon-info-sign" style="font-size:75%; vertical-align: center;"></span>
                        </span>
                           </div><br/>
                </div>
            `,
        };
    }
})();